// extracted by css-extract-rspack-plugin
export default {"statusContainer":"InvitationStatusScreen_statusContainer__dQArH","boldText":"InvitationStatusScreen_boldText__pkrEH"};